export default {"src":"/_next/static/media/reliable.0cd6aa8b.svg","height":1024,"width":1024};